// src/utils/mockData.js
export const mockRepositories = [
  {
    id: 1,
    name: 'awesome-project',
    owner: 'johndoe',
    fullName: 'johndoe/awesome-project',
    isActive: true,
    plan: 'Free Plan',
    usage: { current: 35, limit: 50, feature: 'Similar Issue Detection' },
    lastActivity: '2 hours ago',
    settings: {
      general: { applyToIssues: true, applyToDiscussions: false },
      spamCheck: { enabled: true, action: 'Add \'spam\' label and close', label: 'spam' },
      autoTitle: { enabled: true, bulkRegeneration: false },
      similarIssues: { enabled: true, action: 'Post a comment with links to similar issues', label: 'potential-duplicate' }
    }
  },
  {
    id: 2,
    name: 'backend-api',
    owner: 'johndoe',
    fullName: 'johndoe/backend-api',
    isActive: false,
    plan: 'Pro Plan',
    usage: { current: 120, limit: 500, feature: 'Similar Issue Detection' },
    lastActivity: '1 day ago',
    settings: {
      general: { applyToIssues: true, applyToDiscussions: true },
      spamCheck: { enabled: true, action: 'Add \'spam\' label only', label: 'spam' },
      autoTitle: { enabled: false, bulkRegeneration: false },
      similarIssues: { enabled: true, action: 'Add \'potential-duplicate\' label and comment', label: 'potential-duplicate' }
    }
  },
  {
    id: 3,
    name: 'frontend-app',
    owner: 'johndoe',
    fullName: 'johndoe/frontend-app',
    isActive: true,
    plan: 'Free Plan',
    usage: { current: 8, limit: 50, feature: 'Similar Issue Detection' },
    lastActivity: '5 minutes ago',
    settings: {
      general: { applyToIssues: true, applyToDiscussions: false },
      spamCheck: { enabled: false, action: 'Add \'spam\' label and close', label: 'spam' },
      autoTitle: { enabled: true, bulkRegeneration: false },
      similarIssues: { enabled: true, action: 'Post a comment with links to similar issues', label: 'potential-duplicate' }
    }
  }
]

export const mockActivityLog = [
  {
    id: 1,
    timestamp: '5 minutes ago',
    type: 'Similar Issues Found',
    target: '#125',
    title: 'Bug in login system',
    summary: 'Found 2 similar issues and posted a comment.',
    details: {
      original: 'User unable to log in with special characters in password',
      similarIssues: ['#98: Login fails with special chars', '#112: Password validation issue']
    }
  },
  {
    id: 2,
    timestamp: '2 hours ago',
    type: 'Title Generated',
    target: '#124',
    title: 'User unable to log in with special characters in password',
    summary: 'Generated new title for Issue #124.',
    details: {
      original: 'login not working!!',
      generated: 'User unable to log in with special characters in password'
    }
  },
  {
    id: 3,
    timestamp: '1 day ago',
    type: 'Spam Check',
    target: '#123',
    title: 'Bug in login',
    summary: 'Marked Issue #123 as spam and closed.',
    details: {
      reason: 'Detected promotional content and suspicious patterns'
    }
  }
]

